import styled from "styled-components";
export const MergeUnitContent = styled.div.withConfig({
  displayName: "merge-unitstyles__MergeUnitContent",
  componentId: "sc-1dbfka6-0"
})(["", " grid-template-columns:5fr 2fr 5fr;"], {
  display: "grid",
  marginBottom: "0.5rem",
  height: "100%"
});
export const MergeUnitDividerContainer = styled.div.withConfig({
  displayName: "merge-unitstyles__MergeUnitDividerContainer",
  componentId: "sc-1dbfka6-1"
})(["", " .MuiDivider-root{height:25%;background-color:rgba(54,71,95,0.5);}.MuiIcon-root{", " color:rgba(54,71,95,0.5);}"], {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
}, {
  marginTop: "0.5rem",
  marginBottom: "0.5rem"
});
